<template>
  <div v-loading="loading">
    <div v-if="show == 'false'">
      <el-form style="width: 6.4rem" ref="ruleFormRef" :model="ruleForm" label-width="100px" :rules="rules"
        class="demo-ruleForm" :size="formSize" status-icon label-position="left">
        <el-form-item label="身份证照片" prop="frontSrc">
          <div style="display: flex">
            <el-upload class="upload-demo" style="margin-right: 0.24rem" drag :action="upload_showImage" multiple
              :show-file-list="false" :on-success="onSuccessFrontSrc" :limit="1" list-type="text" ref="upload"
              :on-change="handleChange" :on-remove="handleRemove">
              <el-image v-if="ruleForm.frontSrc" :src="ruleForm.frontSrc">
              </el-image>
              <div v-else>
                <el-icon class="el-icon--upload">
                  <div style="
                      width: 0.2rem;
                      height: 0.2rem;
                      background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADICAYAAACtWK6eAAAAAXNSR0IArs4c6QAACUJJREFUeF7tm0FWVEkQRTPpjeBKhAWIDMtRy6xcBbAKagaOqCHCAsCVWBuR7FPdohxPo/HjP4Iw8zLScyJe/Lzxr1W/LGrhBwIQeJJAhQ0EIPA0AQTh7oDALwggCLcHBBCEewACPgK8gvi40TUIAQQZZNEc00cAQXzc6BqEAIIMsmiO6SOAID5udA1CAEEGWTTH9BFAEB83ugYhgCCDLJpj+gggiI8bXYMQQJBBFs0xfQQQxMeNrkEIIMggi+aYPgII4uNG1yAEEGSQRXNMHwEE8XGjaxACCDLIojmmjwCC+LjRNQgBBBlk0RzTRwBBfNzoGoQAggyyaI7pI4AgPm50DUIAQQZZNMf0EUAQHze6BiGAIIMsmmP6CCCIjxtdgxBAkEEWzTF9BBDEx42uQQggyCCL5pg+Agji4ybtOlwsd+9L+buWsvsQXEv5eLVe3UkHETaZAIJMRqZrOFws9+5rPS+PxPgpfVNau7her051U0maQgBBptAS1h4slsel1hNTZGsnSGIiJS9CEDnS3wdOkuMhDkl+D/YZKhDkGaD+KvLb26pbz9id1vZ5LvGQ8/cgiJ+dq/PtYnnean3vaW6l3N1cnu17eunxEUAQHzd318G7D83dXMrm+vLs1Yx+WicSQJCJwOaUz3l79TCXt1lzNjC9F0GmM3N3vFks39f/PtZ1/yCIG52rEUFc2HxNCkFaa0c369WF7wromkoAQaYSm1GPIDPgvVArggSCR5BA2KJRCCICaYlBEAulXDUIErgPBAmELRqFICKQlhgEsVDKVYMggftAkEDYolEIIgJpiUEQC6VcNQgSuA8ECYQtGoUgIpCWGASxUMpVgyCB+0CQQNiiUQgiAmmJQRALpVw1CBK4DwQJhC0ahSAikJYYBLFQylWDIIH7QJBA2KJRCCICaYlBEAulXDUIErgPBAmELRqFICKQlhgEsVDKVYMggftAkEDYolEIIgJpiUEQC6VcNQgSuA8ECYQtGoUgIpCWGASxUMpVgyCB+0CQQNiiUQgiAmmJQRALpVw1CBK4DwQJhC0ahSAikJYYBLFQylWDIIH7QJBA2KJRCCICaYlBEAulXDUIErgPBAmELRqFICKQlhgEsVDKVYMggftAkEDYolEIIgJpiUEQC6VcNQgSuA8ECYQtGoUgIpCWGASxUMpVgyCB+0CQQNiiUQgiAmmJQRALpVw1CBK4DwQJhC0ahSAikJYYBLFQylWDIIH7QJBA2KJRCCICaYlBEAulXDUIErgPBAmELRqFICKQlhgEsVDKVYMggftAkEDYolEIIgJpiUEQC6VcNQgSuA8ECYQtGoUgIpCWGASxUMpVgyCB+0CQQNiiUQgiAmmJQRALpVw1CBK4DwQJhC0alV6Qw8Vyb3vWr6Xsis78YjE7pbxutb6fcwG1tYv7Uj7PycjS+1cpm6v16i7L9fzfdaQU5HCx3G2lHM+9mTKD59q+E9jU1u5qKR8zypJOkIPF8rjUesINNCCB1k6u16vTTCdPJQhyZLo1XuhakkmSRpDts8Z9rbcvtBbGJiKw09p+lrdbaQQ5ePfhS+ngQTzRffYnX8rm+vLsVYYDpBBE8fFnBphcg45AlleRFILw7KG7sbpJSvIskkKQt4vlOR/pdnNrSw6y/f+eT+vVkSRsRgiCzIBH6/MRQJBHbHmL9Xw32h+bzFusH6vjI94/9jZ+tgvnIf0R2u1XS77Wel5L+fd7V/wMT4CPeX++BXgVGV6K7wCyvHpsLyjFQ/oDGZ5FkKQkefZ42EQqQbYXhSQDS5JMjnSvIA+3Bl93H0uS7Ue6tZTTq/Vqk+3k6V5BHgPairL9flYPvyy1PRe/MPVju9tfltr+LcuXEp8SM7Ug2f41mXs9iu+ctdaObtari7nXQr+NAILYOEmqEESCMTQEQQJxI0ggbNEoBBGBtMQgiIVSrhoECdwHggTCFo1CEBFISwyCWCjlqkGQwH0gSCBs0SgEEYG0xCCIhVKuGgQJ3AeCBMIWjUIQEUhLDIJYKOWqQZDAfSBIIGzRKAQRgbTEIIiFUq4aBAncB4IEwhaNQhARSEsMglgo5apBkMB9IEggbNEoBBGBtMQgiIVSrhoECdwHggTCFo1CEBFISwyCWCjlqkGQwH0gSCBs0SgEEYG0xCCIhVKuGgQJ3AeCBMIWjUIQEUhLDIJYKOWqQZDAfSBIIGzRKAQRgbTEIIiFUq4aBAncB4IEwhaNQhARSEsMglgo5apBkMB9IEggbNEoBBGBtMQgiIVSrhoECdwHggTCFo1CEBFISwyCWCjlqkGQwH0gSCBs0SgEEYG0xCCIhVKuGgQJ3AeCBMIWjUIQEUhLDIJYKOWqQZDAfSBIIGzRKAQRgbTEIIiFUq4aBAncB4IEwhaNQhARSEsMglgo5apBkMB9IEggbNEoBBGBtMQgiIVSrhoECdwHggTCFo1CEBFISwyCWCjlqkGQwH0gSCBs0SgEEYG0xCCIhVKuGgQJ3AeCBMIWjUIQEUhLDIJYKOWqQZDAfSBIIGzRKAQRgbTEIIiFUq4aBAncB4IEwhaNQhARSEvM4WK5d1/rraX2qZrW2tHNenUxJ4NeOwEEsbOaXakQZKe1/av16m72xRBgIoAgJkyaosPFcve+1i9z0q4vz9jZHIATe4E9Edjc8jfvPtzWUvY8ObW1i0/r1ZGnlx4fAQTxcXN3zXkV4e2VG7u7EUHc6PyNB4vlcan1ZFJCayfX69XppB6KZxNAkNkIfQGTJEEOH2RBF4IIIHojvv2/yHEpZfeJjM1Oa0d8auUlPL8PQeYznJWwfSbZBnwtZW+nlNfbP7dSNjulfEaMWWglzQgiwUhIrwQQpNfNci4JAQSRYCSkVwII0utmOZeEAIJIMBLSKwEE6XWznEtCAEEkGAnplQCC9LpZziUhgCASjIT0SgBBet0s55IQQBAJRkJ6JYAgvW6Wc0kIIIgEIyG9EkCQXjfLuSQEEESCkZBeCSBIr5vlXBICCCLBSEivBBCk181yLgkBBJFgJKRXAgjS62Y5l4QAgkgwEtIrAQTpdbOcS0IAQSQYCemVAIL0ulnOJSGAIBKMhPRKAEF63SznkhBAEAlGQnolgCC9bpZzSQggiAQjIb0SQJBeN8u5JAQQRIKRkF4JIEivm+VcEgIIIsFISK8E/gGcNSUFdHk2qAAAAABJRU5ErkJggg==);
                      background-size: 100%;
                      background-repeat: no-repeat;
                    "></div>
                </el-icon>
                <div class="el-upload__text">
                  <div style="font-size: 0.14rem; color: #333333">
                    上传身份证人像面
                  </div>
                </div>
              </div>
            </el-upload>
            <el-upload class="upload-demo" drag :action="upload_showImage" multiple :show-file-list="false"
              :on-success="onSuccessReverseSrc" :limit="1" list-type="text">
              <el-image v-if="ruleForm.reverseSrc" :src="ruleForm.reverseSrc">
              </el-image>
              <div v-else>
                <el-icon class="el-icon--upload">
                  <div style="
                      width: 0.2rem;
                      height: 0.2rem;
                      background: url(data:image/png;base64,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);
                      background-size: 100%;
                      background-repeat: no-repeat;
                    "></div>
                </el-icon>
                <div class="el-upload__text">
                  <div style="font-size: 0.14rem; color: #333333">
                    上传身份证国徽面
                  </div>
                </div>
              </div>
            </el-upload>
          </div>
        </el-form-item>

        <el-form-item label="真实姓名" prop="realName">
          <el-input v-model="ruleForm.realName" placeholder="请输入真实姓名" />
        </el-form-item>

        <el-form-item label="身份证号" prop="idCard">
          <el-input v-model="ruleForm.idCard" placeholder="请输入身份证号" />
        </el-form-item>
      </el-form>
      <div style="display: flex">
        <div class="dataBtn" @click="onSubmit()">提交</div>
      </div>
    </div>
    <!-- 申请成功 -->
    <div style="padding: 1.4rem 0" v-if="show == 'success'">
      <div style="width: 0.48rem; height: 0.48rem; margin: 0 auto">
        <img style="width: 100%; height: 100%" src="@/assets/img/tips／check-circle-fill@2x.png" />
      </div>
      <div style="
          font-size: 0.14rem;
          text-align: center;
          margin-top: 0.16rem;
          margin-bottom: 0.04rem;
          color: #333333;
        ">
        操作成功
      </div>
      <div style="color: #86909c; font-size: 0.14rem; text-align: center">
        等待工作人员审核，预计1-5个工作日
      </div>
    </div>
    <!-- 申请失败 -->
    <div style="padding: 1.4rem 0" v-if="show == 'error'">
      <div style="width: 0.48rem; height: 0.48rem; margin: 0 auto">
        <img style="width: 100%; height: 100%" src="@/assets/img/tips／close-circle-fill@2x.png" />
      </div>
      <div style="
          font-size: 0.14rem;
          text-align: center;
          margin-top: 0.16rem;
          margin-bottom: 0.04rem;
          color: #333333;
        ">
        认证失败
      </div>
      <div style="color: #86909c; font-size: 0.14rem; text-align: center">
        您的身份证号与姓名不匹配，请重新填写信息
      </div>
      <div class="editBtn" @click="show = 'false'">修改信息</div>
    </div>

    <!-- 认证成功 -->
    <div style="padding: 1.4rem 0" v-if="show == 'authentication'">
      <div style="width: 0.48rem; height: 0.48rem; margin: 0 auto">
        <img style="width: 100%; height: 100%" src="@/assets/img/tips／check-circle-fill@2x.png" />
      </div>
      <div style="text-align: center; color: #00b42a">认证已完成</div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { reactive, ref } from "vue";
import type {
  TabsPaneContext,
  FormInstance,
  FormRules,
  ElTable,
} from "element-plus";
import { ElMessage, ElNotification, Message } from "element-plus";
import { Axios } from "@/assets/js/ls_com_axios.js";
let show = ref("false");

// 表单
interface RuleForm {
  name: string;
  frontSrc: string;
  reverseSrc: string;
  idCard: string;
  realName: string;
}
const formSize = ref("default");
const ruleFormRef = ref<FormInstance>();
const percentageValue = 30;
const loading = ref(false);
const progressValue = (percentage) =>
  percentage === 100 ? "100%" : `${percentage}%`;
// do not use same name with ref
const ruleForm = reactive<RuleForm>({
  reverseSrc: "", //国徽
  frontSrc: "", //正面
  idCard: "", //身份证
  realName: "", //姓名
});
const allowedExtensions = [".png", ".jpg", ".jpeg"];
// 上传前
const upload = ref();
const handleChange = (uploadFile: any, uploadFiles: any) => {
  if (
    allowedExtensions.indexOf(
      uploadFile.name
        .substring(uploadFile.name.lastIndexOf("."))
        .toLocaleLowerCase()
    ) == -1
  ) {
    upload.value.handleRemove(uploadFile, 1);
    ElMessage.warning("格式不正确");
    return;
  }
};
// // 删除图片
const fileList = ref([]);
const handleRemove = (file, fileList1, type) => {
  ruleForm.value.licenseSrc = null;
};
const rules = reactive<FormRules>({
  realName: [{ required: true, message: "不能为空！", trigger: "change" }],
  idCard: [{ required: true, message: "不能为空！", trigger: "change" }],
  frontSrc: [{ required: true, message: "不能为空！", trigger: "change" }],
  reverseSrc: [{ required: true, message: "不能为空！", trigger: "change" }],
});
const onSubmit = () => {
  if (ruleForm.frontSrc == "") return ElMessage.warning("请上传正面照");
  if (ruleForm.reverseSrc == "") return ElMessage.warning("请上传反面照");

  ruleFormRef.value.validate((valid: boolean) => {
    if (valid) {
      loading.value = true;
      Axios("post", `/member/real-cert`, ruleForm, false, (res) => {
        if (res.data.code == 200) {
          loading.value = false;
          show.value = "success";
        } else {
          loading.value = false;
          ElMessage({
            message: "提交失败",
            type: "error",
          });
        }
        getIfon();
      }, function () {
        loading.value = false;
      });
    } else {
      loading.value = false;
      ElMessage.warning("请填写完整信息");
    }
  });
};
//信息列表
const loginInfo = ref({});
const getIfon = () => {
  Axios("get", `/member/login-info`, {}, false, (res) => {
    let data = res.data.data;
    loginInfo.value = data;
    if (data.realStatus == 0) {
      show.value = "false";
    } else if (data.realStatus == 1) {
      show.value = "success";
    } else if (data.realStatus == 2) {
      show.value = "authentication";
    } else {
      show.value = "error";
    }
  });
};
getIfon();
/**
 * upload_showImage上传路径
 * 身份证证件照  给ruleForm.showImage  赋值
 */
import { serverBaseUrl } from "@/assets/js/ls_tgServerUrls.js";
const upload_showImage = ref(serverBaseUrl + "/file/upload");

const onSuccessFrontSrc = (res) => {
  if (res.code == 200) {
    ruleForm.frontSrc = res.data.url;
    ElMessage({
      message: "上传成功",
      type: "success",
    });
  } else {
    ElMessage({
      message: "上传失败",
      type: "error",
    });
  }
};
const onSuccessReverseSrc = (res) => {
  if (res.code == 200) {
    ruleForm.reverseSrc = res.data.url;
    ElMessage({
      message: "上传成功",
      type: "success",
    });
  } else {
    ElMessage({
      message: "上传失败",
      type: "error",
    });
  }
};
</script>

<style scoped lang="less">
.upload-demo {
  width: 2.2rem;
  height: 1.9rem;
}

/deep/ .el-image {
  width: 100% !important;
  height: 100% !important;
}

.dataBtn {
  width: 2.68rem;
  padding: 0.12rem 1.06rem;
  background: #C01A26;
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
  opacity: 1;
  text-align: center;
  font-size: 0.14rem;
  color: #fff;
  cursor: pointer;
}

.dataCzBtn {
  width: 1.08rem;
  padding: 0.12rem 0.2rem;
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
  opacity: 1;
  text-align: center;
  font-size: 0.14rem;
  color: #333333;
  margin-left: 0.24rem;
  border: 0.01rem solid #86909c;
}

.editBtn {
  width: 0.88rem;
  height: 0.37rem;
  line-height: 0.37rem;
  text-align: center;
  background: #C01A26;
  color: #fff;
  margin: 0 auto;
  border-radius: 0.08rem 0.08rem 0.08rem 0.08rem;
  margin-top: 0.3rem;
  opacity: 1;
  cursor: pointer;
}

/deep/.el-upload {
  width: 100% !important;
  height: 100% !important;
}

/deep/.el-upload-dragger {
  background: #f5f5f5;
  width: 100% !important;
  height: 100% !important;
}

/deep/.el-upload__input {
  display: none !important;
}
</style>
